const businessHistoryCategoryMap = {
    'MFA': [
        'MFA_POLICY_CHANGED',
        'MFA_IP_ADDRESS_ADDED',
        'MFA_IP_ADDRESS_REMOVED',
        'MFA_IP_ADDRESSES_IMPORTED'
    ],
    'EMAIL_DOMAINS': [
        'EMAIL_DOMAIN_CHANGED'
    ],
    'ENTERPRISE_PREFERENCES': [
        'ENTERPRISE_PREFERENCES_CHANGED'
    ],
    'PASSWORDS': [
        'PASSWORD_POLICY_CHANGED'
    ],
    'ACCOUNTS': [
        'UID_ACCOUNT_LINKED',
        'UID_ACCOUNT_UNLINKED',
        'BULK_MATCH_SSO_USERS'
    ],
    'USERS': [
        'UID_ACCOUNT_CREATED',
        'UID_ACCOUNT_UPDATED',
        'ENTERPRISE_ADMIN_ROLE_ADDED',
        'ENTERPRISE_ADMIN_ROLE_REMOVED',
        'ORG_ADMIN_SELECTION_CHANGED',
        'BULK_ACTION_JOB_CREATED',
        'BULK_ACTION_JOB_UPDATED',
        'SSO_USER_IMPERSONATE',
        'MFA_CREDENTIAL_REMOVED'
    ],
    'SITES': [
        'INSTANCES_STATUS_CHANGED',
        'INSTANCES_UPDATED',
        'ENTERPRISE_ORGANIZATION_ADDED',
        'ENTERPRISE_ORGANIZATION_REMOVED',
        'ORGANIZATION_ATTRIBUTE_SET'
    ],
    'AUDIT_REPORTS': [
        'AUDIT_REPORT_CREATED',
        'AUDIT_REPORT_UPDATED'
    ],
    'INACTIVITY_TIMEOUT': [
        'INACTIVITY_TIMEOUT_CHANGED'
    ],
    'ENTERPRISE': [
        'ENTERPRISE_GROUP_CREATED',
        'ENTERPRISE_GROUP_NAME_CHANGED',
        'ENTERPRISE_GROUP_STATUS_CHANGED',
        'ORGANIZATION_RELOCATED'
    ]
};

export function getEventsByCategory(key: string): string[] {
    for (const [category, events] of Object.entries(businessHistoryCategoryMap)) {
        if (key === category) {
            return events;
        }
    }
    return [];
}
